// apps/client/src/services/plan.ts
import {
  NewPlan,
  Plan,
  PlanCreateResponse,
  PlanGetResponse,
  PlanListResponse,
  PlanUpdateResponse,
  UpdatePlan,
} from '@fsp/types';
import { apiClient } from './apiClient';

export const fetchPlans = async (organisationId: string, signal?: AbortSignal): Promise<Plan[]> => {
  const response = await apiClient.get(`/organisations/${organisationId}/plans`, signal);

  if (!response.ok) {
    throw new Error(`Failed to fetch plans: ${response.statusText}`);
  }

  const result: PlanListResponse = await response.json();
  return result.plans || [];
};

export const fetchPlan = async (organisationId: string, planId: string, signal?: AbortSignal): Promise<Plan> => {
  const response = await apiClient.get(`/organisations/${organisationId}/plans/${planId}`, signal);

  if (!response.ok) {
    throw new Error(`Failed to fetch plan: ${response.statusText}`);
  }

  const result: PlanGetResponse = await response.json();
  return result.plan;
};

export const createPlan = async (organisationId: string, data: NewPlan, signal?: AbortSignal): Promise<Plan> => {
  const response = await apiClient.post(`/organisations/${organisationId}/plans`, data, signal);

  if (!response.ok) {
    const errorResult = await response.json();
    throw new Error(errorResult.message || `Failed to create plan: ${response.statusText}`);
  }

  const result: PlanCreateResponse = await response.json();
  return result.plan;
};

export const updatePlan = async (
  organisationId: string,
  planId: string,
  data: UpdatePlan,
  signal?: AbortSignal
): Promise<Plan> => {
  const response = await apiClient.put(`/organisations/${organisationId}/plans/${planId}`, data, signal);

  if (!response.ok) {
    const errorResult = await response.json();
    throw new Error(errorResult.message || `Failed to update plan: ${response.statusText}`);
  }

  const result: PlanUpdateResponse = await response.json();
  return result.plan;
};

export const deletePlan = async (organisationId: string, planId: string, signal?: AbortSignal): Promise<void> => {
  const response = await apiClient.delete(`/organisations/${organisationId}/plans/${planId}`, signal);

  if (!response.ok) {
    const errorResult = await response.json();
    throw new Error(errorResult.message || `Failed to delete plan: ${response.statusText}`);
  }
};
